import { useFetchNfe } from "hooks";

import { getURLWithParams } from "utils/context";

export const useBoxAndRisk = (params = {}) =>
  useFetchNfe(getURLWithParams("/analytics-internal/clients-numerics", params));
